





import { defineComponent, onMounted } from '@vue/composition-api';
import SpacePage from '@/renderer/components/SpacePage/list.vue';
import { personalSpaceDrawerHandler } from '@/renderer/views/desktop/FileManagement/PersonalSpace/personalSpaceDrawerHandler';
export default defineComponent({
  components: { SpacePage },
  setup(props, context) {
    const { setDefaultDrawer } = personalSpaceDrawerHandler();
    onMounted(() => {
      setDefaultDrawer();
    });
  },
});
